<proffeo-file-upload-list
  (cancelRequested)="cancelUpload($event)"
  (dismiss)="dismissUpload($event)"
  [uploads]="uploadingFiles()"
/>

<div class="grid grid-cols-1 sm:grid-cols-[repeat(auto-fill,minmax(min(100%,400px),1fr))] gap-4">
  @for (file of localFiles(); track file.id) {
    <proffeo-horizontal-file-item
      (preview)="onPreviewFile($event)"
      (delete)="onDeleteFile($event)"
      (download)="onDownloadFile($event)"
      (setAsAvatar)="onSetAsAvatar($event)"
      [file]="file"
      [canSetAsAvatar]="canSetAsAvatar() && file.isImage()"
      [isAvatar]="avatarFileId() === file.id"
      [showButtons]="true"
      class="w-full"
    />
  } @empty {
    <div class="col-span-full text-center py-12">
      <p class="text-proffeo-muted text-sm">{{ 'files.no-files-to-display' | translate }}</p>
    </div>
  }
</div>
